import { ITenantConfig, TenantId } from './tenant.interface';
import { DOQFY_TENANT } from './tenants/doqfy.tenant';
import { ABCL_TENANT } from './tenants/abcl.tenant';

const TENANT_CONFIGS: Record<TenantId, ITenantConfig> = {
  DOQFY: DOQFY_TENANT,
  ABCL: ABCL_TENANT,
};

/**
 * Resolves the active tenant config from the current browser host.
 * ABCL is identified by 'abcl' in the hostname; everything else is DOQFY.
 */
export function resolveTenantConfig(host: string = window.location.host): ITenantConfig {
  const lowerHost = host.toLowerCase();

  if (lowerHost.includes('abcl')) {
    return TENANT_CONFIGS['ABCL'];
  }

  return TENANT_CONFIGS['DOQFY'];
}

export { TENANT_CONFIGS };
